namespace GeniuzPOS.PosShift {
    export interface LogFuctionLvAppForm {
        FuncId: Serenity.LookupEditor;
        UnlockFor: Serenity.LookupEditor;
        CashierLv: Serenity.IntegerEditor;
        ShiftId: Serenity.StringEditor;
        AppCashier: Serenity.LookupEditor;
        AppCashierLv: Serenity.IntegerEditor;
        PosId: Serenity.StringEditor;
        Remark: Serenity.StringEditor;
        CreateBy: Serenity.StringEditor;
        CreateDate: Serenity.DateEditor;
        UpdateBy: Serenity.StringEditor;
        LastUpdate: Serenity.DateEditor;
    }

    export class LogFuctionLvAppForm extends Serenity.PrefixedContext {
        static formKey = 'PosShift.LogFuctionLvApp';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!LogFuctionLvAppForm.init)  {
                LogFuctionLvAppForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.StringEditor;
                var w3 = s.DateEditor;

                Q.initFormType(LogFuctionLvAppForm, [
                    'FuncId', w0,
                    'UnlockFor', w0,
                    'CashierLv', w1,
                    'ShiftId', w2,
                    'AppCashier', w0,
                    'AppCashierLv', w1,
                    'PosId', w2,
                    'Remark', w2,
                    'CreateBy', w2,
                    'CreateDate', w3,
                    'UpdateBy', w2,
                    'LastUpdate', w3
                ]);
            }
        }
    }
}
